__turbopack_context__.v({
  "actions": "SideSheet-module-scss-module__hCIC_W__actions",
  "body": "SideSheet-module-scss-module__hCIC_W__body",
  "bottom": "SideSheet-module-scss-module__hCIC_W__bottom",
  "iconBtn": "SideSheet-module-scss-module__hCIC_W__iconBtn",
  "left": "SideSheet-module-scss-module__hCIC_W__left",
  "overlay": "SideSheet-module-scss-module__hCIC_W__overlay",
  "overlayShow": "SideSheet-module-scss-module__hCIC_W__overlayShow",
  "right": "SideSheet-module-scss-module__hCIC_W__right",
  "sheet": "SideSheet-module-scss-module__hCIC_W__sheet",
  "slideInBottom": "SideSheet-module-scss-module__hCIC_W__slideInBottom",
  "slideInLeft": "SideSheet-module-scss-module__hCIC_W__slideInLeft",
  "slideInRight": "SideSheet-module-scss-module__hCIC_W__slideInRight",
  "slideInTop": "SideSheet-module-scss-module__hCIC_W__slideInTop",
  "slideOutBottom": "SideSheet-module-scss-module__hCIC_W__slideOutBottom",
  "slideOutLeft": "SideSheet-module-scss-module__hCIC_W__slideOutLeft",
  "slideOutRight": "SideSheet-module-scss-module__hCIC_W__slideOutRight",
  "slideOutTop": "SideSheet-module-scss-module__hCIC_W__slideOutTop",
  "srOnly": "SideSheet-module-scss-module__hCIC_W__srOnly",
  "title": "SideSheet-module-scss-module__hCIC_W__title",
  "top": "SideSheet-module-scss-module__hCIC_W__top",
});
